/** @format */

const test = {
  modelName: 'dir_leadsGroup',
  useLocal: !true,
};

const m = {
  title: 'Воронка',
  api: 'mechti/leads_status_group',
  viewName: 'dirLeadGroupView',
  accessName: 'dirs.leads_status_group',
  setAutoReadonly: false,
  config: {
    default: {
      fields:
        'data.task_default,name,status,description,data.statuses,statuses,tasks,data.access,data.status_default,data.result,data.supervisor,data.lawyer,data.version',
      fieldsRO: '',
      fieldsForm:
        'name#7,status#3,data.version#2,data.supervisor#6,data.lawyer#6,description,data.status_default#6,data.task_default#6,data.result,data.statuses,statuses,tasks,data.access',
    },
  },
  viewForm1: { fields: 'name,description' },
  viewForm2: { fields: '' },
  list: [
    { name: 'id', title: 'id', type: 'string', sortable: true, width: 50 },
    { name: 'name', title: 'Наименование', type: 'string', sortable: true, width: 300 },
    { name: 'status', title: 'Статус', type: 'select', options: 'status_active', sortable: true, width: 300 },
    { name: 'department_id', title: 'Отдел', type: 'select', dir: 'department', sortable: true, width: 130, hidden1: true },
    { name: 'description', title: 'Описание', type: 'string', sortable: true, width: 300 },
  ],
  form: [
    { name: 'name', title: 'Наименование', type: 'string', validator: ['req'] },
    { name: 'status', title: 'Статус', type: 'select', options: 'status_active', default: 1, validator: ['req'] },
    { name: 'description', title: 'Описание', type: 'text', rows: 2 },
    {
      calculated: true,
      filters: { leads_status_group_id: { type: 'field', value: 'id' } },
      initData: { leads_status_group_id: { type: 'field', value: 'id' } },
      model: 'dirs.leads_status_group.statuses',
      name: 'statuses',
      sort: [
        { key: 'sort', order: 'ASC' },
        { key: 'id', order: 'ASC' },
      ],
      title: 'Статусы воронки',
      type: 'tableapi',
      accordion: true,
    },
    {
      calculated: true,
      filters: { leads_status_group_id: { type: 'field', value: 'id' } },
      initData: { leads_status_group_id: { type: 'field', value: 'id' } },
      model: 'dirs.leads_task_template',
      name: 'tasks',
      sort: [
        { key: 'name', order: 'ASC' },
        { key: 'id', order: 'ASC' },
      ],
      title: 'Задачи воронки',
      type: 'tableapi',
      accordion: true,
    },
    {
      name: 'data.access',
      title: 'Настройка доступа',
      type: 'table',
      default: [],
      model: {
        standart: true,
        title: 'Доступ',
        list: [
          {
            name: 'type',
            title: 'Тип',
            type: 'select',
            options: [
              { value: 'user', text: 'Пользователь' },
              { value: ' role', text: 'Роль' },
            ],
          },
          {
            name: 'value',
            title: 'Список',
            type: 'select',
            chips: true,
            width: 400,
            dirVar: {
              key: 'type',
              dirName: [
                { value: 'user', name: 'user' },
                { value: 'role', name: 'roles' },
              ],
            },
          },
        ],
        form: [
          {
            name: 'type',
            title: 'Тип',
            type: 'select',
            options: [
              { value: 'user', text: 'Пользователь' },
              { value: 'role', text: 'Роль' },
            ],
            validator: ['req'],
            width: 120,
          },
          { name: 'value', type: 'select', hidden: true },
        ],
        config: {
          watch: 'type',
          default: { fields: 'type,value', fieldsRO: '', fieldsForm: 'type,value' },
          user: { fieldsReplace: { value: { name: 'value', type: 'select', dir: 'user', chips: true } }, fields: 'type,value', fieldsRO: '', fieldsForm: 'type,value' },
          role: { fieldsReplace: { value: { name: 'value', type: 'select', dir: 'roles', chips: true } }, fields: 'type,value', fieldsRO: '', fieldsForm: 'type,value' },
        },
      },
    },
    { name: 'data.status_default', title: 'Статус по умолчанию', type: 'number' },
    { name: 'data.task_default', title: 'Начальная задача', type: 'number' },
    { name: 'data.supervisor', title: 'Пользователь РОП', type: 'selectuser' },
    { name: 'data.lawyer', title: 'Пользователь юрист', type: 'selectuser' },
    { name: 'data.version', title: 'Версия', type: 'select', options: [1, 2], validator: ['req'] },
  ],
  statuses: {
    title: 'Статусы воронки',
    api: 'mechti/leads_status',
    config: {
      default: {
        fields: 'name,action_text,color,data.next,data.mask,status,leads_status_group_id,data.group_id',
        fieldsRO: 'leads_status_group_id',
        fieldsForm: 'name#9,status#3,action_text#9,color#3,data.mask#5,data.next#7,data.group_id',
      },
    },
    list: [
      { name: 'id', title: 'id', type: 'string', sortable: true, width: 40 },
      { name: 'name', title: 'Наименование', type: 'string', sortable: true, width: 200 },
      { name: 'status', title: 'Статус', type: 'select', options: 'status_active', sortable: true, width: 100 },
      { name: 'data.next', title: 'Переход на...', type: 'variant', sortable: false, filterable: false, width: 200 },
      { name: 'description', title: 'Описание', type: 'string', sortable: true, width: 300 },
      { name: 'data.mask', title: 'Переход с...', type: 'string', width: 80 },
    ],
    form: [
      { name: 'name', title: 'Наименование', type: 'string', validator: ['req'], strech: true },
      { name: 'action_text', title: 'Текст для перехода', type: 'string', validator1: ['req'], strech: true },
      { name: 'color', title: 'Цвет', type: 'string' },
      { name: 'data.next', title: 'Переход на...', type: 'base-array-number', strech: true },
      { name: 'data.mask', title: 'Переход с...', type: 'string' },
      { name: 'status', title: 'Статус', type: 'select', options: 'status_active', default: 1 },
      { name: 'leads_status_group_id', title: 'Воронка', type: 'selectapi', api: 'mechti/leads_status_group/select', validator: ['req'] },
      { name: 'data.group_id', title: 'Смена воронки', type: 'selectapi', api: 'mechti/leads_status_group/select' },
    ],
  },
  leads_task_template: {
    title: 'Задача для воронки',
    api: 'mechti/leads_task_template',
    config: {
      configField: 'leads_status_group_id',
      watch: 'leads_status_group_id',
      default: {
        fields:
          'data.task_outer_user,data.task_description,data.user_type,name,status,description,title,leads_status_group_id,need_event,data.event_before,data.leads_status,data,data.action_text,data.forms,data.results,data.task_duration',
        fieldsRO: 'leads_status_group_id',
        fieldsForm:
          'name#9,status#3,title,data.action_text,need_event#4,data.event_before#8,data.task_duration#6,data.user_type#6,data.task_outer_user,data.task_description,data.leads_status,data.forms,description,data.results',
        watch: { leads_status_group_id: { 'data.leads_status': { type: 'value', value: null } } },
      },
    },
    list: [
      { name: 'id', title: 'id', type: 'string', sortable: true, width: 50 },
      { name: 'name', title: 'Наименование ', type: 'string', sortable: true, width: 180 },
      { name: 'title', title: 'Короткое', type: 'string', sortable: true, width: 150 },
      { name: 'need_event', title: 'Напоминание', type: 'select', options: 'yesNo', sortable: true, width: 50 },
      { name: 'status', title: 'Статус', type: 'select', options: 'status_active', sortable: true, width: 80 },
      { name: 'description', title: 'Описание', type: 'string', sortable: true, width: 150 },
      { name: 'data.leads_status', title: 'Доступно для статусов...', type: 'variant', width: 200 },
    ],
    leadsForms: [
      { value: 'object', text: 'Данные объекта' },
      { value: 'client', text: 'Данные клиента' },
      { value: 'client_requirement', text: 'Потребности клиента' },
    ],
    inputTaskFields: [
      { value: 'eventon', text: 'Время события' },
      { value: 'comment', text: 'Комментарий' },
    ],
    inputActionFields: [{ value: 'comment', text: 'Комментарий' }],
    form: [
      { name: 'name', title: 'Наименование полное', type: 'string', validator: ['req'] },
      { name: 'title', title: 'Наименование короткое ', type: 'string', validator: ['req'] },
      { name: 'description', title: 'Описание', type: 'text', rows: 2 },
      { name: 'need_event', title: 'Напоминание', type: 'select', options: 'yesNo', validator: ['req'], default: 0 },
      { name: 'data.event_before', title: 'Время до...', type: 'selectDuration', chips: true, durations: [5, 60, '1Д'], validator: ['req'], default: 1 },
      { name: 'event_template', title: 'Шаблон' },
      { name: 'next_task_template_id', title: 'Следующая задача', type: 'number' },
      { name: 'leads_status_group_id', title: 'Воронка', type: 'selectapi', api: 'mechti/leads_status_group/select', validator: ['req'] },
      { name: 'leads_status', title: 'Воронка', type: 'number' },
      { name: 'data', default: {} },
      { name: 'data.action_text', title: 'Текст действия', type: 'string' },
      { name: 'data.task_duration', title: 'Срок выполнения', type: 'selectDuration', durations: [10, 60, '1Д', '2Д'], validator: ['req'], default: [0] },
      {
        name: 'data.task_outer_user',
        title: 'Внешняя задача для...',
        type: 'select',
        options: [
          { value: 'broker', text: 'Брокер' },
          { value: 'supervisor', text: 'РОП' },
          { value: 'lawyer', text: 'Юрист' },
        ],
        default1: 'broker',
        validator: ['req'],
      },
      { name: 'data.task_description', title: 'Описание для внешней задачи', type: 'text' },

      {
        name: 'data.user_type',
        title: 'Ответственный',
        type: 'select',
        options: [
          { value: 'broker', text: 'Брокер' },
          { value: 'supervisor', text: 'РОП' },
          { value: 'lawyer', text: 'Юрист' },
        ],
        default1: 'broker',
        validator: ['req'],
      },

      {
        name: 'data.leads_status',
        title: 'Доступно для статусов',
        type: 'selectapi',
        chips: true,
        itemField: { text: 'name', value: 'id' },
        api: 'mechti/leads_status',
        filters: { formula: '(d)=>{return {leads_status_group_id: d.leads_status_group_id}}' },
      },
      {
        name: 'data.forms',
        title: 'Формы для заполнения',
        type: 'select',
        options: 'models.dir_leadsGroup.leads_task_template.leadsForms',
        ff: [
          { value: 'object', text: 'Данные объекта' },
          { value: 'client', text: 'Данные клиента' },
          { value: 'client_requirement', text: 'Потребности клиента' },
        ],
      },
      { name: 'data.results', type: 'lead-task-results' },
      { name: 'status', title: 'Статус', type: 'select', options: 'status_active', default: 1, validator: ['req'] },
    ],
  },
};
export default Object.assign({}, test, m);
